import './styles.scss';
import createElement from '../../utils/createElement';
import algeriaVideo from '../../../img/algeria.mp4';
import loadVideo from '../../utils/loader';
import { rmCl, addCl } from '../../utils/elementClasses';
import Wrap from '../ScreenWrap';


class Screen5 {
    constructor(loader, updateParams){
        this.html = {};
        this.wrap = null;
        this.loader = loader;
        this.updateParams = updateParams;

        this.isFocused = false;
        this.isEntered = false;
        this.isLoaded = false;

        this.canPlay = true;

        this.STEP2_FROM_PERCENT = 55;

        this.showHelp = true;

        this.request = null;
        this.lastLoadedPercent = 0;

        this.ic = 'algeria_invisible';

        this.currentGuiAction = null;

        this.initListeners = this.initListeners.bind(this);
        this.toBegin = this.toBegin.bind(this);
        this.insertRequest = this.insertRequest.bind(this);
    }

    render(mountNode){
        this.html.mountNode = mountNode;

        this.html.mainTitle = <h2 class="algeria__main-title">
            Алжир
        </h2>;

        this.html.shadowFilter = <div class="algeria__shadow-filter"/>;

        this.html.countryName = <h3 class="algeria__country-name">Алжир</h3>;

        this.html.video = <video
            class={`algeria__video`}
            id="algeria-video"
            muted
        />;

        this.html.content1 = <div class="algeria__content-1">
            { this.html.title1 = <h3 class="algeria__title-1">
                В пес
                <br/>
                <span class="algeria__title-1-sub">ках</span>
            </h3> }
            { this.html.help1 = <span class="algeria__help-1">
                Удерживай клавишу
                <br/>
                «Пробел»,
                <br/>
                чтобы снять видео
                <br/>
                в пустыне
            </span> }
        </div>;

        this.html.sandLayer = <div class="algeria__sand-layer"/>;

        this.html.content2 = <div class="algeria__content-2">
            { this.html.title2 = <h3 class="algeria__title-2">Защита<br/>от &nbsp;пыли</h3> }
            { this.html.help2 = <span class="algeria__help-2">Компактный корпус<br/>с защитой от пыли</span> }
        </div>;

        this.html.container = <div class="algeria" id="algeria">
            { this.html.shadowFilter }
            { this.html.mainTitle }
            { this.html.countryName }
            { this.html.content1 }
            { this.html.content2 }
            { this.html.video }
            { this.html.sandLayer }
        </div>;

        this.wrap = new Wrap(this.html.container);
        this.wrap.mountTo(this.html.mountNode);

        this.initListeners();
        this.guiAction('inactive');
    }

    initListeners(){
        const self = this;

        const can = () => self.isFocused && self.isEntered && self.isLoaded && self.canPlay;

        this.html.video.addEventListener('timeupdate', event => {
            if (can()) {
                self.checkVideoProgress();
            }
        }, false);

        this.html.video.addEventListener('ended', event => {
            if (can()) {
                self.canPlay = false;
                //self.html.video.style.opacity = 0;
                self.html.video.currentTime = 0;
                //setTimeout(function () {
                //    self.html.video.style.opacity = null;
                //}, 500);
                self.checkVideoProgress();
                self.guiAction('content1 and help');
            }
        }, false);

        window.addEventListener('keyup', event => {
            if (event.keyCode === 32){
                //if (can()){
                    self.html.video.pause();
                    // if (!this.showHelp){
                    //     this.guiAction('content1');
                    // }
                //}else{
                    self.canPlay = true;
                //}
            }
        }, false);

        window.addEventListener('keydown', event => {
            if (event.keyCode === 32 && can()) {
                self.html.video.play();
                if (this.showHelp){
                    this.showHelp = false;
                }

                // if (!this.showHelp){
                //     if (!self.checkVideoProgress()) {
                //         this.guiAction('content1');
                //     }
                // }
            }
        }, false);
    }

    paramsUpdated() {
        if (this.isFocused) {
            this.updateParams(this.isFocused, this.isEntered, this.isLoaded);
        }
    }

    size(heigth, width){
        this.wrap.size(heigth, width);
    }

    float(floatVal){
        this.wrap.float(floatVal);
    }

    focus() {
        this.isFocused = true;
        this.paramsUpdated();
    }

    unFocus() {
        this.isFocused = false;
        this.paramsUpdated();
        this.toBegin();
    }

    clickEnter() {
        this.isEntered = true;
        this.paramsUpdated();
        if (!this.isLoaded){
            this.guiAction('loading');
            this.loader.loadStarted(this.lastLoadedPercent);
            this.loadVideo();
        }else{
            this.loaded();
        }
    }

    preload() {
        loadVideo(algeriaVideo,
            p => {
                // console.log('algeria ', p);
                this.lastLoadedPercent = p;
                if (this.isFocused && this.isEntered) {
                    this.loader.progress(p)
                }
            }).then(videoSrc => {
            this.html.video.src = videoSrc;
            if (this.isEntered && this.isFocused) {
                this.loaded();
                this.loader.loadFinished();
            }
        });
    }

    loadVideo() {
        //const self = this;
        //loadVideo(algeriaVideo, this.loader.progress, 0, this.insertRequest).then(videoSrc => {
        //    self.html.video.src = videoSrc;
        //    self.loaded();
        //    self.loader.loadFinished();
        //});
        if (this.html.video.src) {
            this.loaded();
            this.loader.loadFinished();
        }
    }

    loaded() {
        this.isLoaded = true;
        this.loader.loadFinished();
        this.paramsUpdated();
        this.toBegin();
    }

    clickExit() {
        this.isEntered = false;
        this.paramsUpdated();
        this.guiAction('inactive');
    }

    guiAction(action){

        const ic = this.ic;

        if (action === this.currentGuiAction){
            return;
        }

        this.currentGuiAction = action;

        addCl([
            this.html.mainTitle,
            this.html.countryName,
            this.html.content1,
            this.html.content2,
            this.html.help1,
            this.html.video
        ], ic);

        switch (action){
            case 'inactive':
                rmCl(this.html.mainTitle, ic);
                this.html.sandLayer.style.opacity = 0;
                break;

            case 'loading':
                rmCl(this.html.countryName, ic);
                this.html.sandLayer.style.opacity = 0;
                break;

            case 'content1 and help':
                rmCl([
                    this.html.content1,
                    this.html.countryName,
                    this.html.help1,
                    this.html.video
                ], ic);
                this.html.sandLayer.style.opacity = 0;
                break;

            case 'content1':
                rmCl([
                    this.html.content1,
                    this.html.countryName,
                    this.html.video
                ], ic);
                break;

            case 'content2':
                rmCl([
                    this.html.content2,
                    this.html.countryName,
                    this.html.video
                ], ic);
                if (this.isEntered && this.isFocused) {
                    ga('s8.send', 'event', 'Algeria', 'final_text');
                }
                break;

            case 'nothing':
                rmCl([
                    this.html.countryName,
                    this.html.video
                ], ic);
                break;
        }
    }

    checkVideoProgress(){

        const title1From = 0;
        const title1To = 20;

        const nothingFrom = 20;
        const nothingTo = 55;

        const step2From = 75;
        const step2To = 100;

        const currentPercent = Math.round(this.html.video.currentTime * 100 /this.html.video.duration);

        const opacity = currentPercent/(100 - this.STEP2_FROM_PERCENT);

        if (currentPercent >= this.STEP2_FROM_PERCENT) {
            this.guiAction('content2');
        }

        if (currentPercent > title1From && currentPercent < title1To){
            this.guiAction('content1')
        }

        if (currentPercent > nothingFrom && currentPercent < nothingTo) {
            this.guiAction('nothing');
        }

        if (opacity < 1) {
            this.html.sandLayer.style.opacity = opacity;
        }

        return currentPercent >= this.STEP2_FROM_PERCENT;
    }

    toBegin(){
        const self = this;
        if (!this.isEntered){
            return;
        }
        if (this.isLoaded) {
            this.showHelp = true;
            this.guiAction('loading');
            setTimeout(() => {
                self.html.video.pause();
                try {
                    self.html.video.currentTime = 0;
                } catch (e) {}
                self.guiAction('content1 and help');
            }, 200);
        }else{
            if (this.request){
                this.request.abort();
            }
            this.loader.loadFinished();
            this.guiAction('inactive');
            this.isEntered = false;
            this.updateParams();
        }
    }

    insertRequest(request){
        this.request = request;
    }
}


export default Screen5;


// WEBPACK FOOTER //
// ./src/js/screens/Screen5/index.js